<template>
	<div :class="['top-opportunities__cards',{'top-opportunities__cards-col':column}]">
		<template v-for="(job, index) in jobs" :key="index">
			<div :class="['top-opportunities__card', card_color]"  v-if="index < display_count">
				<div class="top-opportunities__card-number">{{ index+1 }}</div>
				<a :href="calculate_link(job)" :title="`${job['org-name']} - ${job.title}`">
					<div class="top-opportunities__card-avatar">
						<div class="top-opportunities__card-logo-container">
							<img class="top-opportunities__card-logo" :src="$filters.analyseImage(job.logo,'logosm','logoxl')" :alt="job['org-name']" width="54" height="54" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
						</div>
					</div>
					<div class="top-opportunities__card-body">
						<div class="top-opportunities__card-info">
							<p class="top-opportunities__card-company">{{ job['org-name'] }}</p>
							<p class="top-opportunities__card-title">{{ job.title }}</p>
							<p class="top-opportunities__card-location">{{ job['location-text'] }}</p>
						</div>
						<div class="top-opportunities__card-cat" :class="job.type.toLowerCase().trim()">
							<p>{{ job.type }}</p>
						</div>
					</div>
				</a>
			</div>
		</template>
	</div>

  <div class="top-opportunities__btn-group">
    <a class="btn btn-border--blue md:hidden" href="#" v-if="limited" @click.prevent="showAll" aria-label="See All 10">See all 10</a>
    <a class="btn btn-blue-dark" href="/search/discover" aria-label="Discover all opportunities">Discover all opportunities</a>
  </div>
</template>

<script>
export default {
	props: {
		data: {
			type: String,
			default: false
		},
		column: {
			type: Boolean,
			default: false
		},
		card_color: {
			type: String,
			default: 'bg-grey'
		},
	},

	data() {
		return {
			jobs: false,
			limited: true
		}
	},
	created() {
		this.jobs = JSON.parse(this.data);
	},
	mounted() {
		console.log("screen size",this.$grid);
	},
	methods: {
		calculate_link(job) {
			if (job.slug) {
				return '/opportunity/'+job.slug;
			}
			if (job['job-id']) {
				return '/opportunity/redirect/'+job['job-id'];
			}
			return '#';
		},
		showAll() {
			this.limited = false;
		}
	},
	computed: {
		display_count() {
			if (this.$grid.breakpoint == "" || this.$grid.breakpoint == "sm") {
				if (this.limited) {
					return 6;
				}
			}
			return 10;
		}
	}
}
</script>
